import { TableColumnType } from 'antd'
import React from 'react'
import { Dimen } from '../../../models/dimen'
import { Checks } from '../../../models/setting'
import styles from './drugStatic.module.css'

// 药品销售统计
export const DrugStaticColumns = (
  startIndex: number,
  CKLRSJData?: boolean,
  settings?: any,
): TableColumnType<any>[] => {

  // 新老目录展示方式 (老目录没有区分药品类别/无型号)
  const getProcuctInfo = (item: any) => {
    const accountUnit = item.accountUnit ? item.accountUnit : '-'
    const packSpec = item.packSpec ? item.packSpec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'

    if (settings?.[Checks.MLKG] == 1) {
      // 生产厂家 + 包装规格 + 剂型
      return tenantSupplierName + '/' + packSpec + '/' + doseCategory
    } else {
      // 生产厂家 + 包装规格 + 剂型 + 包装（账簿）单位
      return tenantSupplierName + '/' + packSpec + '/' + doseCategory + '/' + accountUnit
    }
  }

  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
      width: Dimen.Num,
    },
    {
      title: '药品名称',
      dataIndex: '',
      align: 'left',
      key: 'name',
      render: function Element(_, record) {
        return (
          <div style={{ height: '55px' }}>
            <p
              className={styles.nameText}
            >
              {record.name}
            </p>
            <p
              className={styles.productText}
            >
              {getProcuctInfo(record)}
            </p>
          </div>
        )
      },
    },
    {
      title: '开票项目',
      dataIndex: 'billingCategory',
      width: Dimen.BillingCategory,
      align: 'center',
      key: 'billingCategory',
    },
    // {
    //   title: "进货单价",
    //   dataIndex: "costUnit",
    //   align: "right",
    //   key: "costUnit",
    //   render: (_: any, t: any) => {
    //     return t.costUnit
    //       ? parseFloat((t.costUnit as unknown) as string).toFixed(5)
    //       : 0.0;
    //   },
    // },
    // {
    //   title: "销售单价",
    //   dataIndex: "retailUnit",
    //   align: "right",
    //   key: "retailUnit",
    //   render: (_: any, t: any) => {
    //     return t.retailUnit
    //       ? parseFloat((t.retailUnit as unknown) as string).toFixed(5)
    //       : 0.0;
    //   },
    // },

    // 1.4.0需求
    {
      title: '库存数量',
      children: [
        {
          title: '整存数量',
          dataIndex: 'invWholeCount',
          width: Dimen.Count,
          align: 'center',
          key: 'invWholeCount',
          render: function Element(_: any, record: any) {
            return (
              <div>
                <p>
                  {record.invWholeCount} {record.accountUnit}
                </p>
              </div>
            )
          },
        },
        {
          title: '拆零数量',
          dataIndex: 'invSplitCount',
          width: Dimen.Count,
          align: 'center',
          key: 'invSplitCount',
          render: function Element(_: any, record: any) {
            return (
              <div>
                <p>
                  {record.invSplitCount} {record.splitUnit}
                </p>
              </div>
            )
          },
        },
      ],
    } as TableColumnType<any>,
    {
      title: '销售数量',
      children: [
        {
          title: '整存数量',
          dataIndex: 'wholeCount',
          width: Dimen.Count,
          align: 'center',
          key: 'wholeCount',
          render: function Element(_: any, record: any) {
            return (
              <div>
                <p>
                  {record.wholeCount} {record.accountUnit}
                </p>
              </div>
            )
          },
        },
        {
          title: '拆零数量',
          dataIndex: 'splitCount',
          width: Dimen.Count,
          align: 'center',
          key: 'splitCount',
          render: function Element(_: any, record: any) {
            return (
              <div>
                <p>
                  {record.splitCount} {record.splitUnit}
                </p>
              </div>
            )
          },
        },
      ],
    } as TableColumnType<any>,

    {
      title: '药品成本',
      children: [
        {
          title: '整存成本',
          dataIndex: 'wholeCost',
          align: 'right',
          width: Dimen.Count,
          key: 'wholeCost',
          render: (_: any, t: any) => {
            return !CKLRSJData ? '***' : t.wholeCost ? t.wholeCost : '0.00'
          },
        },
        {
          title: '拆零成本',
          align: 'right',
          dataIndex: 'splitCost',
          width: Dimen.Count,
          key: 'splitCost',
          render: (_: any, t: any) => {
            return !CKLRSJData ? '***' : t.splitCost ? t.splitCost : '0.00'
          },
        },
      ],
    } as TableColumnType<any>,
    {
      title: '销售额',
      children: [
        {
          title: '整存销售额',
          align: 'right',
          dataIndex: 'wholeRetail',
          width: Dimen.Count,
          key: 'wholeRetail',
          render: (_: any, t: any) => {
            return t.wholeRetail ? t.wholeRetail : '0.00'
          },
        },
        {
          title: '拆零销售额',
          align: 'right',
          dataIndex: 'splitRetail',
          width: Dimen.Count,
          key: 'splitRetail',
          render: (_: any, t: any) => {
            return t.splitRetail ?
              t.splitRetail
              : '0.00'
          },
        },
      ],
    } as TableColumnType<any>,
    {
      title: '利润',
      align: 'right',
      dataIndex: 'profit',
      width: Dimen.Profit,
      key: 'profit',
      render: (_: any, t: any) => {
        return !CKLRSJData ? '***' : t.profit
          ? t.profit
          : '0.00'
      },
    },
    // {
    //   title: '供应商',
    //   align: 'center',
    //   dataIndex: 'vendorName',
    //   width: Dimen.Profit,
    //   key: 'vendorName',
    //   render: (_: any, t: any) => {
    //     return t.vendorName ? t?.vendorName : '-'
    //   },
    // },
  ]
}
